// Gator actions are per-toast onClick callbacks, and a Vuex mutation cannot reach
// evaultApp's modal state or $router. The shell registers its handler here.
let handler = null

export default {
  register (fn) {
    handler = fn
  },
  unregister () {
    handler = null
  },
  emit (actionData) {
    if (handler) {
      handler(actionData)
    }
  }
}
